{
  "name": "runjs",
  "type": "module",
  "version": "1.73.0",
  "private": true,
  "description": "Online JavaScript Playground",
  "author": "Maximiliano Garcia Mortigliengo",
  "license": "ISC",
  "homepage": "https://github.com/MaxiGarcia13/runjs#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/MaxiGarcia13/runjs.git"
  },
  "bugs": {
    "url": "https://github.com/MaxiGarcia13/runjs/issues"
  },
  "scripts": {
    "prepare": "simple-git-hooks",
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint",
    "lint:fix": "eslint --fix",
    "phoenix": "rm -rf dist node_modules package-lock.json && npm install && npm run build"
  },
  "dependencies": {
    "@maxigarcia/js-utils": "^1.15.0",
    "acorn": "^8.18.0",
    "eslint-plugin-react-refresh": "^0.5.7",
    "monaco-editor": "^0.55.1",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "zustand": "^5.0.15"
  },
  "devDependencies": {
    "@eslint-react/eslint-plugin": "^5.20.8",
    "@maxigarcia/eslint-config": "^1.14.1",
    "@tailwindcss/vite": "^4.3.3",
    "@types/node": "^26.6.2",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.1",
    "esbuild": "^0.28.2",
    "eslint-plugin-react-refresh": "^0.5.7",
    "lint-staged": "^17.5.1",
    "simple-git-hooks": "^2.14.0",
    "tailwindcss": "^4.3.3",
    "typescript": "^6.0.3",
    "vite": "^8.3.1"
  },
  "simple-git-hooks": {
    "pre-commit": "npx lint-staged"
  },
  "lint-staged": {
    "*.{js,jsx,ts,tsx}": "npm run lint:fix"
  }
}
